import React from "react";

const styles = `
.controls-health-print-sheet {
  width: 210mm;
  min-height: 297mm;
  box-sizing: border-box;
  background: #ffffff;
  color: #111827;
  padding: 10mm;
  font-family: "Segoe UI", "Helvetica Neue", Arial, sans-serif;
  display: grid;
  gap: 8px;
  border: 1px solid #d1d5db;
  box-shadow: 0 16px 40px rgba(15, 23, 42, 0.08);
}

.controls-health-print-header {
  display: grid;
  gap: 6px;
  border-bottom: 1px solid #cbd5e1;
  padding-bottom: 6px;
}

.controls-health-print-title {
  margin: 0;
  font-size: 22px;
  line-height: 1.15;
}

.controls-health-print-subtitle,
.controls-health-print-meta,
.controls-health-print-footer {
  font-size: 11px;
  color: #475569;
  line-height: 1.4;
}

.controls-health-print-pill-row {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.controls-health-print-pill {
  display: inline-flex;
  align-items: center;
  padding: 3px 8px;
  border-radius: 999px;
  background: #f1f5f9;
  border: 1px solid #dbe3ee;
  font-size: 11px;
}

.controls-health-print-kpi-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 6px;
}

.controls-health-print-detail-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px;
}

.controls-health-print-card {
  border: 1px solid #dbe3ee;
  border-radius: 10px;
  background: #f8fafc;
  padding: 8px;
  min-width: 0;
  display: grid;
  gap: 6px;
}

.controls-health-print-label {
  color: #64748b;
  font-size: 10px;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.controls-health-print-kpi-value {
  font-size: 20px;
  font-weight: 700;
  line-height: 1;
}

.controls-health-print-section-header {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 8px;
}

.controls-health-print-section-title {
  font-size: 13px;
  font-weight: 700;
}

.controls-health-print-table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
}

.controls-health-print-table th,
.controls-health-print-table td {
  border-top: 1px solid #dbe3ee;
  padding: 5px 4px;
  text-align: left;
  vertical-align: top;
  font-size: 10px;
  line-height: 1.3;
  word-break: break-word;
}

.controls-health-print-table th {
  color: #64748b;
  font-weight: 700;
  border-top: none;
  padding-top: 0;
}

.controls-health-print-list {
  display: grid;
  gap: 6px;
}

.controls-health-print-list-row {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 8px;
  font-size: 11px;
  line-height: 1.35;
}

.controls-health-print-list-row--stacked {
  border-top: 1px solid #dbe3ee;
  padding-top: 6px;
}

.controls-health-print-list-row--stacked:first-child {
  border-top: none;
  padding-top: 0;
}

.controls-health-print-empty {
  font-size: 11px;
  color: #64748b;
}

.controls-health-print-screen-preview {
  border: 1px solid #d1d5db;
  border-radius: 12px;
  background: #e2e8f0;
  padding: 12px;
  overflow: auto;
}

[data-controls-health-print-root] {
  position: fixed;
  left: -200vw;
  top: 0;
  opacity: 0;
  pointer-events: none;
}

@media print {
  @page {
    size: A4 portrait;
    margin: 8mm;
  }

  body * {
    visibility: hidden !important;
  }

  [data-controls-health-print-root],
  [data-controls-health-print-root] * {
    visibility: visible !important;
  }

  [data-controls-health-print-root] {
    position: absolute !important;
    inset: 0 auto auto 0 !important;
    left: 0 !important;
    top: 0 !important;
    width: 100% !important;
    opacity: 1 !important;
  }

  .controls-health-print-sheet {
    width: 100%;
    min-height: auto;
    border: none;
    box-shadow: none;
    padding: 0;
  }

  .controls-health-print-screen-preview,
  .modal-a11y-backdrop {
    display: none !important;
  }
}
`;

export default function ControlsHealthPrintStyles() {
  return (
    <style data-testid="controls-health-print-styles">
      {styles}
    </style>
  );
}
